import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import actions from 'features/layout/redux/actions';
import api from 'api';
import React from 'react';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import {useDeleteApi} from 'common/hooks/useDeleteApi';
import {unpackId} from 'common/diplomatIdUtil';
import {usePartnersRefs} from 'redux/partners/hooks/usePartnersRefs';
import {useTransactionsRefs} from 'redux/transactions/hooks/useTransactionsRefs';
import DeleteKeyDialog from 'features/layout/DialogRoutes/dialogs/keys/DeleteKeyDialog';

type Props = {
   data: INav;
   onClose: () => void;
};

const DeleteSSLCertificateDialog = ({data, onClose}: Props) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();
   const {id} = unpackId(data.id);
   const partners = usePartnersRefs(id, 'ssl');
   const transactions = useTransactionsRefs(id, 'ssl');

   const onSuccess = () => {
      dispatch(actions.loadTreeNav());
      onClose();
   };
   const {request} = useDeleteApi(api.sslKeys + `/${id}`, {
      onSuccess,
   });
   const dialogTitle =
      data?.objectType === DiplomatObjectType.enum.SSL_CLIENT_CERTIFICATE
         ? t('Delete SSL Client Certificate')
         : t('Delete SSL Server Certificate');
   const handleConfirm = () => {
      request();
   };

   return (
      <DeleteKeyDialog
         dialogTitle={dialogTitle}
         data={data}
         partners={partners}
         transactions={transactions}
         onConfirm={handleConfirm}
         onClose={onClose}
      />
   );
};

export default DeleteSSLCertificateDialog;
